import React from 'react'

function AttendanceAnalytics() {
  return (
    <div>AttendanceAnalytics</div>
  )
}

export default AttendanceAnalytics